// eslint-disable-next-line import/prefer-default-export
export default {
  getTodaysDate() {
    return new Date()
      .toJSON()
      .slice(0, 10)
      .replace(/-/g, '/');
  },

  getSevenDaysAgoDate() {
    const date = new Date();
    return new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000)
      .toJSON()
      .slice(0, 10)
      .replace(/-/g, '-');
  },
};
